var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "1200", scrollable: "", persistent: "" },
          model: {
            value: _vm.realogramDetailsModal,
            callback: function($$v) {
              _vm.realogramDetailsModal = $$v
            },
            expression: "realogramDetailsModal"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "popup add_store_popup realogram" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex justify-space-between align-center mb-4"
                },
                [
                  _c("div", { staticClass: "page-title-bar mb-0" }, [
                    _c("img", {
                      staticStyle: { "margin-right": "10px", width: "30px" },
                      attrs: { src: require("@/assets/img/camera.png") }
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("Realogram Details")) + " ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "modal-header-right" },
                    [
                      _c(
                        "v-chip",
                        { staticClass: "info-chip mr-2", attrs: { small: "" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Shelf")) +
                              ": " +
                              _vm._s(_vm.shelfItem.shelfId) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "v-chip",
                        { staticClass: "info-chip", attrs: { small: "" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Section")) +
                              ": " +
                              _vm._s(_vm.shelfItem.section) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "v-chip",
                        { staticClass: "info-chip", attrs: { small: "" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Floor")) +
                              ": " +
                              _vm._s(_vm.shelfItem.floor) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-card-text",
                { staticClass: "content" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "fill-height pb-0",
                          attrs: { cols: "3" }
                        },
                        [
                          _c("v-data-table", {
                            staticClass:
                              "tbl-type01 products flex-grow-1 fill-height",
                            attrs: {
                              headers: _vm.captureTimeHeader,
                              items: _vm.captureTimeItems,
                              "hide-default-footer": true,
                              height: "100%",
                              "fixed-header": "",
                              "item-class": _vm.getCaptureRowClass,
                              "single-select": "",
                              "item-key": "captureTime"
                            },
                            on: { "click:row": _vm.handleCaptureRowClick },
                            model: {
                              value: _vm.selectedCaptureTime,
                              callback: function($$v) {
                                _vm.selectedCaptureTime = $$v
                              },
                              expression: "selectedCaptureTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "fill-height pb-0",
                          attrs: { cols: "4" }
                        },
                        [
                          _c("v-data-table", {
                            staticClass:
                              "tbl-type01 products flex-grow-1 fill-height",
                            attrs: {
                              headers: _vm.productHeader,
                              items: _vm.productItems,
                              "hide-default-footer": true,
                              "items-per-page": -1,
                              height: "100%",
                              "fixed-header": "",
                              "item-class": _vm.getProductRowClass,
                              "item-key": "clusterId",
                              "single-select": ""
                            },
                            on: { "click:row": _vm.handleProductRowClick },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.no",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.productItems.indexOf(item) + 1
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.article_name",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.productInfo[0].article_name ||
                                              "-"
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.status",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      item && item.weakConnection > 0
                                        ? _c(
                                            "v-chip",
                                            {
                                              staticClass: "ma-2 ml-0",
                                              attrs: {
                                                color: "red",
                                                outlined: "",
                                                small: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    left: "",
                                                    color: "red"
                                                  }
                                                },
                                                [_vm._v(" mdi-information ")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ESL might be missing"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-chip",
                                            {
                                              staticClass: "ma-2 ml-0",
                                              attrs: {
                                                color: "green",
                                                outlined: "",
                                                small: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    left: "",
                                                    color: "green"
                                                  }
                                                },
                                                [_vm._v(" mdi-check-circle ")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Completed")) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.selectedProduct,
                              callback: function($$v) {
                                _vm.selectedProduct = $$v
                              },
                              expression: "selectedProduct"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "imageSection d-flex flex-column",
                          attrs: { cols: "5" }
                        },
                        [
                          _c("div", { staticClass: "image-header" }, [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _vm.selectedProduct[0] &&
                                  _vm.selectedProduct[0].weakConnection > 0
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "ma-2 ml-0",
                                          attrs: {
                                            color: "red",
                                            outlined: "",
                                            small: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { left: "", color: "red" }
                                            },
                                            [_vm._v(" mdi-information ")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("ESL might be missing")
                                              ) +
                                              " "
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-chip",
                                        {
                                          staticClass: "ma-2 ml-0",
                                          attrs: {
                                            color: "green",
                                            outlined: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                left: "",
                                                color: "green"
                                              }
                                            },
                                            [_vm._v(" mdi-check-circle ")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Completed")) +
                                              " "
                                          )
                                        ],
                                        1
                                      ),
                                  _c("div", { on: { click: _vm.handleSwap } }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/img/swap.png"),
                                        alt: ""
                                      }
                                    })
                                  ])
                                ],
                                1
                              ),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedProduct[0] &&
                                        _vm.selectedProduct[0].productInfo[0] &&
                                        _vm.selectedProduct[0].productInfo[0]
                                          .article_id
                                    ) +
                                    " | " +
                                    _vm._s(
                                      _vm.selectedProduct[0] &&
                                        _vm.selectedProduct[0].productInfo[0] &&
                                        _vm.selectedProduct[0].productInfo[0]
                                          .article_name
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]),
                          _c("v-divider", {
                            staticClass: "my-2",
                            staticStyle: {
                              border: "1px solid rgb(0, 0, 0, 0.5)"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "imgContainer flex-grow-1" },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.swapImage,
                                    expression: "swapImage"
                                  }
                                ],
                                ref: "shelfImgContainer",
                                staticClass: "vrog-container"
                              }),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.swapImage,
                                    expression: "!swapImage"
                                  }
                                ],
                                ref: "canvasContainer",
                                staticClass: "vrog-container"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-auto" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn type-search mt-5",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleClose()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Close")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }